export default __webpack_public_path__ + "dfa1928e7199c9b4ce8c4821b25a4a2b.webp";